import { Col, Collapse, message, Modal, Row, Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";
import diagnosticoJornadaCarreiraExemploImg from "shared/assets/images/diagnostico-jornada-carreira-exemplo.jpg";
import diagnosticoDadosPublicosExemploImg from "shared/assets/images/diagnostico-dados-publicos-exemplo.jpg";
import diagnosticoDadosPrivadoExemploImg from "shared/assets/images/diagnostico-dados-privados-exemplo.jpg";
import diagnosticoConclusaoExemploImg from "shared/assets/images/diagnostico-conclusao-exemplo.jpg";
import { Team } from "shared/interfaces/Team";
import CarouselDiagnosticExample from "./CarouselDiagnosticExample";
import { Link } from "react-router-dom";
import { subscribeNewsletter } from "shared/service/StrmService";
import { PlayCircleFilled } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import PanelDiagnosticButtons from "./PanelDiagnosticButtons";
import "./About.scss";
import { WhatsAppContactConsultor } from "shared/helpers/whatsapp-contact";
import { useSelector } from "react-redux";
import { MonitoredDataState } from "explorer/reducers/monitored-data";

const { success } = Modal;

interface AboutProps {
  team?: Team;
  history: any;
  getTeams: any;
}

const About: React.FC<AboutProps> = (props) => {
  const { t } = useTranslation();
  const { team, getTeams } = props;
  const { totalMonitoredArtists } = useSelector(
    (state: MonitoredDataState) => state.monitoredData
  );

  const signupSubscription = async () => {
    const response = await subscribeNewsletter();
    if (response)
      message.success(
        t("pages.Diagnosticos.PriorDiagnosis.sucessoInscricaoNewsletter")
      );
    else if (response)
      message.error(
        t("pages.Diagnosticos.PriorDiagnosis.erroInscricaoNewsletter")
      );
  };

  const showModalVideo = () => {
    success({
      width: 800,
      closable: true,
      icon: null,
      okButtonProps: {
        className: "botao-roxo",
      },
      content: (
        <iframe
          className="embedded-video-16-9"
          src="https://www.youtube.com/embed/pIXGRHuWhog"
          allowFullScreen
          title="video"
          style={{ width: "100%", border: 0, height: 400 }}
        />
      ),
    });
  };

  return (
    <div className="previa-diagnostico diagnostic-about">
      <div className="video-botoes">
        <div className="content">
          <div className="texts">
            <button className="play-button" onClick={showModalVideo}>
              <PlayCircleFilled />
            </button>
            <h1>
              {t("pages.Diagnosticos.PriorDiagnosis.artistasMonitorados", {
                totalArtists: totalMonitoredArtists,
              })}
            </h1>
            <span>{t("pages.Diagnosticos.PriorDiagnosis.titulo")}</span>
          </div>
        </div>
      </div>

      <Row justify="center" className="linha-botoes" gutter={16}>
        <button className="botao-roxo">
          <Link to="/checkout">
            {t("pages.Diagnosticos.PriorDiagnosis.fazerDiagnosticoCompleto")}
          </Link>
        </button>
        <button className="botao-borda-roxa">
          <a target="_blank" href={WhatsAppContactConsultor} rel="noreferrer">
            {t("pages.Diagnosticos.PriorDiagnosis.falarComEspecialista")}
          </a>
        </button>
      </Row>
      <Row className="row-sessoes-diagnostico">
        <Typography.Title className="title">
          {t("pages.Diagnosticos.PriorDiagnosis.conhecaQuatroSessoesTitulo")}
        </Typography.Title>
        <p className="texto-sessoes-diagnostico">
          {t("pages.Diagnosticos.PriorDiagnosis.conhecaQuatroSessoesDescricao")}
        </p>
      </Row>
      <PanelDiagnosticButtons teamId={team?.id} getTeams={getTeams} />

      <Row gutter={[0, 55]} style={{ margin: "64px 0" }}>
        <Col xs={24}>
          <Typography.Title className="title-explanation default-padding">
            {t("pages.Diagnosticos.PriorDiagnosis.jornadaCarreira")}
          </Typography.Title>
          <div className="blur-img">
            <div className="modal-inside-blur-img">
              <p className="title-modal">
                {t("pages.Diagnosticos.PriorDiagnosis.entendaQualEstagio")}
              </p>
              <p className="message-modal">
                {t(
                  "pages.Diagnosticos.PriorDiagnosis.quaisSaoSeusPrincipaisDesafios"
                )}
              </p>
              <div className="buttons">
                <button className="botao-roxo">
                  <Link to="/checkout">
                    {t(
                      "pages.Diagnosticos.PriorDiagnosis.fazerDiagnosticoCompleto"
                    )}
                  </Link>
                </button>
                <button className="botao-borda-roxa">
                  <a
                    target="_blank"
                    href={WhatsAppContactConsultor}
                    rel="noopener noreferrer"
                  >
                    {t(
                      "pages.Diagnosticos.PriorDiagnosis.falarComEspecialista"
                    )}
                  </a>
                </button>
              </div>
            </div>
            <img
              alt=""
              src={diagnosticoJornadaCarreiraExemploImg}
              className="img-desktop"
            />
          </div>
        </Col>

        <Col xs={24}>
          <Typography.Title className="title-explanation default-padding">
            {t("pages.Diagnosticos.PriorDiagnosis.diagnosticoDadosPublicos")}
          </Typography.Title>
          <div className="blur-img">
            <div className="modal-inside-blur-img">
              <p className="title-modal">
                {t(
                  "pages.Diagnosticos.PriorDiagnosis.diagnosticoDadosPublicosModalTitulo"
                )}
              </p>
              <p className="message-modal">
                {t(
                  "pages.Diagnosticos.PriorDiagnosis.diagnosticoDadosPublicosModalMensagem"
                )}
              </p>
              <div className="buttons">
                <button className="botao-roxo">
                  <Link to="/checkout">
                    {t(
                      "pages.Diagnosticos.PriorDiagnosis.fazerDiagnosticoCompleto"
                    )}
                  </Link>
                </button>
                <button className="botao-borda-roxa">
                  <a
                    target="_blank"
                    href={WhatsAppContactConsultor}
                    rel="noopener noreferrer"
                  >
                    {t(
                      "pages.Diagnosticos.PriorDiagnosis.falarComEspecialista"
                    )}
                  </a>
                </button>
              </div>
            </div>
            <img
              alt=""
              src={diagnosticoDadosPublicosExemploImg}
              className="img-desktop"
            />
          </div>
        </Col>

        <Col xs={24}>
          <Typography.Title className="title-explanation default-padding">
            {t("pages.Diagnosticos.PriorDiagnosis.diagnósticoDadosPrivados")}
          </Typography.Title>
          <div className="blur-img">
            <div className="modal-inside-blur-img">
              <p className="title-modal">
                {t(
                  "pages.Diagnosticos.PriorDiagnosis.diagnósticoDadosPrivadosModalTitulo"
                )}
              </p>
              <p className="message-modal">
                {t(
                  "pages.Diagnosticos.PriorDiagnosis.diagnósticoDadosPrivadosModalMensagem"
                )}
              </p>
              <div className="buttons">
                <button className="botao-roxo">
                  <Link to="/checkout">
                    {t(
                      "pages.Diagnosticos.PriorDiagnosis.fazerDiagnosticoCompleto"
                    )}
                  </Link>
                </button>
                <button className="botao-borda-roxa">
                  <a
                    target="_blank"
                    href={WhatsAppContactConsultor}
                    rel="noopener noreferrer"
                  >
                    {t(
                      "pages.Diagnosticos.PriorDiagnosis.falarComEspecialista"
                    )}
                  </a>
                </button>
              </div>
            </div>
            <img
              alt=""
              src={diagnosticoDadosPrivadoExemploImg}
              className="img-desktop"
            />
          </div>
        </Col>

        <Col xs={24}>
          <Typography.Title className="title-explanation default-padding">
            {t("pages.Diagnosticos.PriorDiagnosis.conclusao")}
          </Typography.Title>
          <div className="blur-img">
            <div className="modal-inside-blur-img">
              <p className="title-modal">
                {t("pages.Diagnosticos.PriorDiagnosis.conclusaoModalTitulo")}
              </p>
              <p className="message-modal">
                {t("pages.Diagnosticos.PriorDiagnosis.conclusaoModalMensagem")}
              </p>
              <div className="buttons">
                <button className="botao-roxo">
                  <Link to="/checkout">
                    {t(
                      "pages.Diagnosticos.PriorDiagnosis.fazerDiagnosticoCompleto"
                    )}
                  </Link>
                </button>
                <button className="botao-borda-roxa">
                  <a
                    target="_blank"
                    href={WhatsAppContactConsultor}
                    rel="noopener noreferrer"
                  >
                    {t(
                      "pages.Diagnosticos.PriorDiagnosis.falarComEspecialista"
                    )}
                  </a>
                </button>
              </div>
            </div>
            <img
              alt=""
              src={diagnosticoConclusaoExemploImg}
              className="img-desktop"
            />
          </div>
        </Col>
      </Row>
      <Row className="row-example-diagnostic">
        <Col>
          <Typography.Title>
            {t(
              "pages.Diagnosticos.PriorDiagnosis.vejaComoRecebeSeuDiagnostico"
            )}
          </Typography.Title>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24}>
          <CarouselDiagnosticExample />
        </Col>
      </Row>
      <Row justify="center" style={{ marginTop: "3rem", marginBottom: "3rem" }}>
        <Col
          xs={24}
          style={{
            marginTop: "30px",
          }}
        >
          <Typography.Title>
            {t("pages.Diagnosticos.PriorDiagnosis.aindaTemDuvidas")}
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <p className="texto-duvidas">
            {t("pages.Diagnosticos.PriorDiagnosis.aindaTemDuvidasDescricao")}
          </p>
        </Col>
        <Col xs={24}>
          <button className="botao-borda-roxa">
            <a target="_blank" href={WhatsAppContactConsultor} rel="noreferrer">
              {t("pages.Diagnosticos.PriorDiagnosis.falarComEspecialista")}
            </a>
          </button>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24}>
          <Collapse
            bordered={false}
            className="faq"
            expandIcon={() => <FontAwesomeIcon icon={faChevronDown} />}
            expandIconPosition="end"
          >
            {Array(10)
              .fill(1)
              .map((_, i) => (
                <Collapse.Panel
                  header={
                    <>
                      <span style={{ color: "#5779FF" }}>{i + 1}</span>{" "}
                      {t(`pages.Diagnosticos.FAQ.pergunta${i + 1}`)}
                    </>
                  }
                  key={i}
                >
                  <p>
                    <Trans
                      i18nKey={t(`pages.Diagnosticos.FAQ.resposta${i + 1}`)}
                    />
                  </p>
                </Collapse.Panel>
              ))}
          </Collapse>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24}>
          <Typography.Title
            style={{
              maxWidth: "600px",
              marginTop: "3rem",
            }}
          >
            {t(
              "pages.Diagnosticos.PriorDiagnosis.entendaComoInterpretarDiagnostico"
            )}
          </Typography.Title>
        </Col>
      </Row>
      <Row className="row-video">
        <Col xs={24} className="borda-bottom-colorida">
          <iframe
            title="Vídeo explicativo"
            className="embedded-video-16-9"
            src="https://www.youtube.com/embed/ukLu7BPLJ6s"
            allowFullScreen
          />
        </Col>
      </Row>
      <Row className="row-receber-atualizacoes">
        <Col xs={24}>
          <Typography.Title>
            {t("pages.Diagnosticos.PriorDiagnosis.gostouDoConteudo")}
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <p>
            {t("pages.Diagnosticos.PriorDiagnosis.gostouDoConteudoDescricao")}
          </p>
        </Col>
        <Col xs={24} style={{ display: "flex", justifyContent: "center" }}>
          <button className="botao-roxo" onClick={signupSubscription}>
            {t("pages.Diagnosticos.PriorDiagnosis.queroReceberAtualizacoes")}
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default About;
